import {
  PlainTooltip,
  Button,
  SystemIcon,
  Typography,
  IconButton,
  Box,
} from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { TooltipButtonProps } from '@/shared/types';
import { formatViewCount } from '@/shared/utils';

const FORMATTED_WIDTH: Record<number, string> = {
  1: 'w-[10px]',
  2: 'w-[20px]',
  3: 'w-[30px]',
  4: 'w-[34px]',
  5: 'w-[44px]',
  6: 'w-[54px]',
};

export const TooltipButton = ({
  text,
  count,
  icon,
  onClick,
  isTriggered: triggered,
}: TooltipButtonProps) => {
  const formattedCount = formatViewCount(Number(count));

  return (
    <PlainTooltip text={text}>
      <Button className="gap-1.5 border-none p-0" onClick={onClick}>
        <SystemIcon name={icon} solid={triggered} testId={`${text}-button`} />
        <Box className={twJoin('flex', FORMATTED_WIDTH[formattedCount.length])}>
          <Typography variant="body1" className="text-w-gray-900">
            {formattedCount}
          </Typography>
        </Box>
      </Button>
    </PlainTooltip>
  );
};

export const TooltipIconButton = ({
  id,
  text,
  icon,
  onClick,
  isTriggered: triggered,
}: TooltipButtonProps) => (
  <PlainTooltip text={text}>
    <IconButton
      id={id}
      size="lg"
      className="shrink-0"
      onClick={onClick}
      data-testid={`${text}-button`}
    >
      <SystemIcon name={icon} solid={triggered} />
    </IconButton>
  </PlainTooltip>
);
